/**
 * StatusBadge - colored badge for post / payment statuses
 */
import { Badge } from "@/components/ui/badge";

const MAP = {
    rascunho: { label: "Rascunho", cls: "bg-white/10 text-foreground border border-white/10" },
    agendado: { label: "Agendado", cls: "bg-[#6B21D9]/20 text-[#A78BFA] border border-[#6B21D9]/30" },
    publicado: { label: "Publicado", cls: "bg-[#2DD4BF]/15 text-[#2DD4BF] border border-[#2DD4BF]/25" },
    falhado: { label: "Falhado", cls: "bg-[#FB7185]/15 text-[#FB7185] border border-[#FB7185]/25" },
    pendente: { label: "Pendente", cls: "bg-[#FBBF24]/15 text-[#FBBF24] border border-[#FBBF24]/25" },
    aprovado: { label: "Aprovado", cls: "bg-[#2DD4BF]/15 text-[#2DD4BF] border border-[#2DD4BF]/25" },
    rejeitado: { label: "Rejeitado", cls: "bg-[#FB7185]/15 text-[#FB7185] border border-[#FB7185]/25" },
    ativa: { label: "Ativa", cls: "bg-[#2DD4BF]/15 text-[#2DD4BF] border border-[#2DD4BF]/25" },
    pausada: { label: "Pausada", cls: "bg-[#FBBF24]/15 text-[#FBBF24] border border-[#FBBF24]/25" },
    concluida: { label: "Concluída", cls: "bg-white/10 text-foreground border border-white/10" },
    aberto: { label: "Aberto", cls: "bg-[#60A5FA]/15 text-[#60A5FA] border border-[#60A5FA]/25" },
    em_curso: { label: "Em curso", cls: "bg-[#FBBF24]/15 text-[#FBBF24] border border-[#FBBF24]/25" },
    resolvido: { label: "Resolvido", cls: "bg-[#2DD4BF]/15 text-[#2DD4BF] border border-[#2DD4BF]/25" },
};

export default function StatusBadge({ status }) {
    const info = MAP[status] || { label: status, cls: "bg-white/10" };
    return <Badge className={`rounded-md font-medium ${info.cls}`}>{info.label}</Badge>;
}
